import cleanedFilename from '~/util/cleanedFilename';

export default {
  MANUAL_SUBSCRIPTION_PAGE: `${cleanedFilename(
    __filename,
  )}-manual-subscription-page`,
};
